export const enum AccountIdentityProvider {
  None = 'none',
  AzureAD = 'azureAD',
}
